import { createTheme } from '@mui/material/styles'
import { theme } from './styled-components-theme'

export const muiTheme = createTheme(theme.mui)
